<template>
  <div id="step5" class="sscw-container sscw-flex-column">
    <h2 id="top" class="sscw-step-title">
      {{ wizardContent.step5_header ? wizardContent.step5_header : "step5_header" }}
    </h2>
    <h3 class="step-description">
      {{
        wizardContent.step5_Description
          ? wizardContent.step5_Description
          : "step5_Description"
      }}
    </h3>

    <div class="step-image-group">
      <div class="sscw-mobile-hidden desktop-icon">
        <img :src="theme.grundrissIcon" width="42px" alt="icon" />
      </div>
      <div class="sscw-step-input-group">
        <div class="mobile-img sscw-desktop-hidden">
          <img :src="theme.grundrissIcon" width="42px" alt="icon" />
        </div>
        <div class="sscw-buttons-container">
          <div class="sscw-buttons-header">
            <div class="sscw-buttons-title">
              {{
                wizardContent.step5_houseFoundation_label
                  ? wizardContent.step5_houseFoundation_label
                  : "step5_houseFoundation_label"
              }}
            </div>
          </div>
          <div class="sscw-buttons-row">
            <div class="sscw-button" @click="handleHouseFoundationClick('None')">
              <div class="btn-label-img">
                <div class="sscw-button-img-container">
                  <img
                    class="sscw-button-img"
                    :src="theme.noneFoundation"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="sscw-button-text">
                  {{
                    wizardContent.step5_houseFoundation_none
                      ? wizardContent.step5_houseFoundation_none
                      : "step5_houseFoundation_none"
                  }}
                </div>
              </div>
              <div class="sscw-button-bottom">
                <div class="sscw-button-radio-option">
                  <div
                    class="sscw-button-radio-option-inside"
                    :class="{
                      hidden: houseFoundation != 'None',
                    }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="sscw-button" @click="handleHouseFoundationClick('Complete')">
              <div class="btn-label-img">
                <div class="sscw-button-img-container">
                  <img
                    class="sscw-button-img"
                    :src="theme.completeFoundation"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="sscw-button-text">
                  {{
                    wizardContent.step5_houseFoundation_complete
                      ? wizardContent.step5_houseFoundation_complete
                      : "step5_houseFoundation_complete"
                  }}
                </div>
              </div>
              <div class="sscw-button-bottom">
                <div class="sscw-button-radio-option">
                  <div
                    class="sscw-button-radio-option-inside"
                    :class="{ hidden: houseFoundation != 'Complete' }"
                  ></div>
                </div>
              </div>
            </div>
            <div class="sscw-button" @click="handleHouseFoundationClick('Partial')">
              <div class="btn-label-img">
                <div class="sscw-button-img-container">
                  <img
                    class="sscw-button-img"
                    :src="theme.partialFoundation"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="sscw-button-text">
                  {{
                    wizardContent.step5_houseFoundation_partial
                      ? wizardContent.step5_houseFoundation_partial
                      : "step5_houseFoundation_partial"
                  }}
                </div>
              </div>
              <div class="sscw-button-bottom">
                <div class="sscw-button-radio-option">
                  <div
                    class="sscw-button-radio-option-inside"
                    :class="{ hidden: houseFoundation != 'Partial' }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="step-image-group">
      <div class="sscw-mobile-hidden desktop-icon">
        <img :src="theme.garage" width="42px" alt="icon" />
      </div>
      <div class="sscw-step-input-group">
        <div class="mobile-img sscw-desktop-hidden">
          <img :src="theme.garage" width="42px" alt="icon" />
        </div>
        <div class="sscw-w-full">
          <div class="sscw-step-input sscw-container">
            <div class="sscw-step-input-content">
              <div class="flex-col">
                <div class="flex-row">
                  <div class="sscw-step-input-description">
                    <span>
                      {{
                        wizardContent.step5_garageSpace_label
                          ? wizardContent.step5_garageSpace_label
                          : "step5_garageSpace_label"
                      }}
                    </span>
                  </div>
                  <div class="sscw-step-input-box">
                    <input
                      type="text"
                      pattern="\d*"
                      class="sscw-input"
                      name="size"
                      id="sscw-size"
                      v-model="garageSpaceDisplay"
                      @blur="handleGarageSpaceValidation"
                      placeholder="1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sscw-container flex">
            <div class="sscw-slider-container">
              <input
                type="range"
                v-model="garageSpace"
                :min="garageSpaceOptions.min"
                :max="garageSpaceOptions.max"
                :step="garageSpaceOptions.interval"
                @change="handleGarageSpaceValidation"
              />
            </div>

            <div class="sscw-slider-range-container">
              <div class="sscw-slider-range-label">{{ garageSpaceOptions.min }}</div>
              <div class="sscw-slider-range-label">mehr als 5</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import displayInEuro from "@/utils/displayInEuro";
import getTheme from "@/utils/theme";
import wizardContent from "@/utils/extnWizardContent";

export default {
  name: "ClickWizardStep1",
  props: ["appraisalValue", "increasePerYear", "years"],
  data() {
    return {
      theme: getTheme(),
      wizardContent: wizardContent(),
      garageSpaceOptions: {
        dotSize: 22,
        height: 4,
        width: "auto",
        direction: "ltr",
        data: null,
        dataLabel: "label",
        dataValue: "value",
        min: 0,
        max: 6,
        interval: 1,
        clickable: true,
        duration: 0.5,
        dotStyle: {
          "background-color": "#112C42",
        },
        processStyle: {
          "background-color": "#112C42",
        },
      },
    };
  },
  methods: {
    displayInEuro,
    displayInCurrency: (v) => `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
    handleHouseFoundationClick(value) {
      this.houseFoundation = value;
      this.$emit("onValidation", this.validateStep());
    },
    emitUpdate() {
      this.$emit("updated", {
        houseFoundation: this.houseFoundation,
      });
    },
    validateStep() {
      return true;
    },
    garageSpaceValidation(inputData) {
      if (inputData) {
        return (this.isGarageSpaceValid = true);
      }
      return (this.isGarageSpaceValid = false);
    },
    handleGarageSpaceValidation(event) {
      this.garageSpaceValidation(event.target.value);
      this.$emit("onValidation", this.validateStep());
    },
  },
  computed: {
    wizardState() {
      return this.$store.wizardState;
    },
    garageSpace: {
      get() {
        return this.$store.wizardState.garageSpace;
      },
      set(value) {
        this.$store.wizardState.garageSpace = value;
      },
    },
    isGarageSpaceValid: {
      get() {
        return this.$store.wizardState.isGarageSpaceValid;
      },
      set(value) {
        this.$store.wizardState.isGarageSpaceValid = value;
        this.$emit("onValidation", this.validateStep());
      },
    },
    garageSpaceDisplay: {
      get() {
        if (this.garageSpace < 6) return this.garageSpace;
        return "mehr als 5";
      },
      set(newValue) {
        if (typeof newValue == "string" && newValue.includes("mehr")) {
          this.garageSpace = 6;
        } else if (newValue < 6 && newValue >= 0) {
          this.garageSpace = newValue;
        } else if (newValue > 6) {
          this.garageSpace = 6;
        } else if (newValue < 0) {
          this.garageSpace = 0;
          return;
        }
        this.$forceUpdate();
      },
    },
    houseFoundation: {
      get() {
        return this.$store.wizardState.houseFoundation;
      },
      set(value) {
        this.$store.wizardState.houseFoundation = value;
      },
    },
    isHouseFoundationValid: {
      get() {
        return this.$store.wizardState.isHouseFoundationValid;
      },
      set(value) {
        this.$store.wizardState.isHouseFoundationValid = value;
        this.$emit("onValidation", this.validateStep());
      },
    },
  },

  mounted() {
    this.emitUpdate();
    this.$emit("onValidation", this.validateStep());

    this.$nextTick(() => {
      document
        .querySelector("#shortcode-2-977 > ss-lebenswert-wizard-extn")
        ?.shadowRoot.querySelector("#top")
        ?.scrollIntoView();
      window.scrollTo(0, -150);
    });
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.hero-components-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 18px;
}
.sscw-buttons-container {
  width: 100%;
  margin: 0 0;

  background: #f0f3f5;
  border-radius: 8px;

  padding-top: 0;
  padding-bottom: 0;
  padding-left: 4px;
  padding-right: 4px;
}

.sscw-buttons-header {
  max-width: 95%;
  margin: 0 auto;
  margin-bottom: 14px;
}

.sscw-buttons-title {
  font-style: normal;
  font-weight: 500;
  font-size: 17px;
  line-height: 20px;

  display: flex;
}

.sscw-buttons-row {
  max-width: 95%;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sscw-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;

  padding: 8px 16px;

  min-height: 36px;
}
.btn-label-img {
  display: flex;
  gap: 10px;
  align-items: center;
}
.sscw-button-img-container {
  width: 48px;
  margin: 0 auto;
}

.sscw-button-img {
  width: 100%;
}

.sscw-button-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  text-align: center;

  margin-top: 4px;
}

.sscw-button-bottom {
  display: flex;
  justify-content: center;

  margin-top: 10px;
}

.sscw-button-radio-option {
  width: 18px;
  height: 18px;

  background: #ffffff;
  border: 2px solid #112c42;
  border-radius: 10px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.sscw-button-radio-option-inside {
  width: 12px;
  height: 12px;

  background: var(#112c42);
  border-radius: 10px;
}

.sscw-button:hover .sscw-button-radio-option-inside {
  display: block;
}

@media (max-width: 991.98px) {
  .sscw-button-text {
    font-size: 14px;
  }
}

.jump-to-top {
  visibility: hidden;
}
.error-message {
  color: red;
}
.step-image-group {
  display: flex;
  gap: 34px;
  align-items: center;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.sscw-flex-column {
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.sscw-step-input-group {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 6px;
}

.mobile-img {
  margin-left: 14px;
}

.sscw-w-full {
  flex: 1;
}

.sscw-step-input-description {
  display: flex;
}

@media (min-width: 1190px) {
  .sscw-step-input-group {
    width: 683px;
    padding: 18px 0;
  }

  .flex-col {
    width: 100%;
  }

  .flex-row {
    display: flex;
    gap: 16px;
    flex-direction: column;
  }

  .sscw-buttons-row {
    max-width: 95%;
    margin: 0 auto;

    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
  }
  .sscw-buttons-row-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sscw-button {
    display: flex;
    flex-direction: column;

    background: #ffffff;
    border-radius: 6px;
    cursor: pointer;
    justify-content: center;
    padding-top: 0px;
    padding-left: 0px;
    padding-right: 0px;

    min-height: 124px;
  }
  .btn-label-img {
    display: flex;
    gap: 0;
    flex-direction: column;
  }
}

.step-description {
  margin: unset;
}
</style>
